import CertificationRecord from '@/views/webpc/CashierDesk/CertificationRecordApp/CertificationRecord'

// 定义路由路径数列表
export default [{
  path: '/certification',
  name: '验证记录',
  component: CertificationRecord
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CertificationRecordApp/routers/index.js